if (!customElements.get('zenlart-catalog-carousel')) {
 customElements.define('zenlart-catalog-carousel', class extends HTMLElement {
  connectedCallback() {
   this.track = this.querySelector('.zen-catalog__grid--carousel');
   if (!this.track || this.controller) return;
   this.controller = new AbortController();
   const options = { signal: this.controller.signal };
   this.update = () => {
    const items = [...this.track.children], rect = this.track.getBoundingClientRect();
    const visible = items.map((item, index) => ({index, rect: item.getBoundingClientRect()})).filter(x => x.rect.left < rect.right - 8 && x.rect.right > rect.left + 8);
    this.querySelector('.zen-catalog__position').textContent = visible.length ? (visible[0].index + 1) + '–' + (visible.at(-1).index + 1) + ' de ' + items.length : '';
    this.querySelector('[data-carousel-step="-1"]').disabled = this.track.scrollLeft < 2;
    this.querySelector('[data-carousel-step="1"]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
   };
   this.querySelectorAll('[data-carousel-step]').forEach(button => button.addEventListener('click', () => {
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({left: Number(button.dataset.carouselStep) * (this.track.clientWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   }, options));
   this.track.addEventListener('scroll', this.update, {...options, passive:true});
   this.observer = new ResizeObserver(this.update); this.observer.observe(this.track); this.update();
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
 });
}
